export const TEXT_INPUT = {
  SIZE: {
    BIG: 'big',
    SMALL: 'small',
    DEFAULT: 'default'
  }
}
